<div class="tall-card bg" [style]="style" 
     [ngClass]="{'circle-background': bgImage == 'circles', 
                 'd-shaped-background': bgImage == 'd-shape', 
                 'm-shaped-background': bgImage == 'm-shape',
                 'circle-background-prestige': bgImage == 'circles-prestige',
                 'd-shaped-background-prestige': bgImage == 'd-shape-prestige',
                 'm-shaped-background-prestige': bgImage == 'm-shape-prestige',}">
       <div>
            <div class="content-section">
                <h2>{{ title }}</h2>
                <p>{{ description }}</p>
            </div>
       </div>
</div>
